<!-- Botón con tooltip pequeño -->
<template>
  <v-flex
    xs4
    sm3
    md4
    lg3
  >
    <v-tooltip
      v-if="render"
      :color="toolTipColor"
      top
    >
      <template #activator="{ on }">
        <v-btn
          :disabled="disabled"
          icon
          v-on="on"
          @click="$emit('click')"
        >
          <v-icon :size="size" :color="iconColor">
            {{ prependIcon }}
          </v-icon>
        </v-btn>
      </template>
      <span class="text-caption">{{ tooltip }}</span>
    </v-tooltip>
  </v-flex>
</template>

  <script>
  export default {
    name: 'GlobalIconToolTip',
    props: {
      tooltip: {
        type: String,
        default: ''
      },
      prependIcon: {
        type: String,
        default: 'edit'
      },
      iconColor: {
        type: String,
        default: 'primary'
      },
      toolTipColor: {
        type: String,
        default: 'primary'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        default: '24px'
      },
      // btnSize: {
      //   type: String,
      //   default: '24px'
      // },
      render: {
        type: Boolean,
        default: true
      },
    }
  }
  </script>
